(function () {
  const confirmModal = document.getElementById('cart-clear-confirm-modal');
  if (confirmModal && confirmModal.parentElement !== document.body) document.body.append(confirmModal);
  const confirmMessage = confirmModal?.querySelector('[data-js-confirm-message]');
  const confirmBtn = confirmModal?.querySelector('[data-js-confirm]');

  const container = document.getElementById('availability-indicator-root');
  if (!container) return;

  const productId = parseInt(container.dataset.productId, 10);
  const productCategory = container.dataset.productCategory;
  const routes = KROWN.settings.routes;
  const locales = KROWN.settings.locales;

  const toMiamiDate = (offsetDays = 0) => {
    const now = new Date();
    const miami = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
    miami.setDate(miami.getDate() + offsetDays);
    const pad = (n) => String(n).padStart(2, '0');
    return `${miami.getFullYear()}-${pad(miami.getMonth() + 1)}-${pad(miami.getDate())}`;
  };

  const RESERVE_THRESHOLD = productCategory === 'Breads & Buns' ? 0 : 0;
  const LOW_STOCK_THRESHOLD = 10;

  let checking = false;
  let lastCartItemCount = 0;

  const getProductForm = () => document.querySelector('product-form');
  const getAddToCartBtn = () => document.querySelector('[data-js-product-add-to-cart]');
  const getButtonsRoot = () => document.getElementById('availability-buttons-root');

  const getButtonClasses = () => {
    const btn = getAddToCartBtn();
    if (!btn) return 'button button--solid button--product';
    return [...btn.classList]
      .filter(c => c !== 'button--loader' && c !== 'add-to-cart')
      .join(' ');
  };

  const buildButton = (text, className, options = {}) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = className;
    if (options.id) btn.id = options.id;
    if (options.disabled) btn.disabled = true;
    const span = document.createElement('span');
    span.className = 'button__text';
    span.textContent = text;
    btn.appendChild(span);
    return btn;
  };

  const requestCartClearConfirmation = (itemCount) => {
    return new Promise((resolve) => {
      if (!confirmModal) { resolve(true); return; }

      const itemWord = itemCount === 1 ? 'item' : 'items';
      confirmMessage.textContent =
        `Changing the pickup location or day will clear the ${itemCount} ${itemWord} out of your cart.`;

      let settled = false;
      const settle = (result) => {
        if (settled) return;
        settled = true;
        observer.disconnect();
        resolve(result);
      };

      confirmBtn.addEventListener('click', () => {
        confirmModal.hide();
        settle(true);
      }, { once: true });

      const observer = new MutationObserver(() => {
        if (!confirmModal.classList.contains('active')) settle(false);
      });
      observer.observe(confirmModal, { attributes: true, attributeFilter: ['class'] });

      confirmModal.show();
    });
  };

  const switchDeliveryDate = async (dateLabel) => {
    if (lastCartItemCount > 0) {
      const confirmed = await requestCartClearConfirmation(lastCartItemCount);
      if (!confirmed) return;

      await fetch(`${routes.cart_url}/clear.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
    }

    await fetch(routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { delivery_date: dateLabel } })
    });

    try {
      const config = JSON.parse(localStorage.getItem('domaselo_delivery_config')) || {};
      config.date = dateLabel;
      localStorage.setItem('domaselo_delivery_config', JSON.stringify(config));
      document.dispatchEvent(new CustomEvent('deliveryConfigSaved', { detail: config, bubbles: true }));
    } catch (_) {}

    window.location.reload();
  };

  const resetUI = () => {
    container.innerHTML = '';

    const btnsRoot = getButtonsRoot();
    if (btnsRoot) btnsRoot.innerHTML = '';

    const productForm = getProductForm();
    if (productForm) productForm.classList.remove('availability--sold-out');
  };

  const setSoldOutState = (label, reserveLabel, dateLabel) => {
    const productForm = getProductForm();
    if (productForm) productForm.classList.add('availability--sold-out');

    const btnsRoot = getButtonsRoot();
    if (!btnsRoot) return;

    const baseClasses = getButtonClasses();

    btnsRoot.appendChild(
      buildButton(label, `${baseClasses} availability-sold-out-btn`, { disabled: true })
    );

    if (reserveLabel && dateLabel) {
      const reserveBtn = buildButton(reserveLabel, baseClasses, { id: 'availability-reserve-btn' });
      reserveBtn.addEventListener('click', () => switchDeliveryDate(dateLabel));
      btnsRoot.appendChild(reserveBtn);
    }
  };

  async function checkAvailability() {
    if (checking) return;
    checking = true;

    try {
      const cartResponse = await fetch(`${routes.cart_url}.js`);
      const cart = await cartResponse.json();

      const attrs = cart.attributes ?? {};
      const locationId = attrs['Pickup-Location-Id'];
      const deliveryDate = attrs['delivery_date'];
      lastCartItemCount = cart.item_count || 0;

      resetUI();

      if (!locationId || !deliveryDate) return;

      const TODAY = 0;
      const TOMORROW = 1;
      const today = toMiamiDate(TODAY);
      const tomorrow = toMiamiDate(TOMORROW);

      const deliveryDateIso = deliveryDate === 'today' ? today
        : deliveryDate === 'tomorrow' ? tomorrow
        : deliveryDate;

      const availability = await new InventoryFilter()
        .getProductAvailability(productId, locationId, deliveryDateIso);

      const qty = availability.available_quantity ?? 0;
      const effectivelyAvailable = availability.available && qty > RESERVE_THRESHOLD;

      if (effectivelyAvailable) {
        if (qty <= LOW_STOCK_THRESHOLD) {
          const unitsLeft = qty <= 5 ? qty : qty - 5;
          const text = unitsLeft === 1
            ? locales.availability_low_stock_one
            : locales.availability_low_stock_other.replace('{count}', unitsLeft);

          const dot = document.createElement('span');
          dot.className = 'availability-low-stock__dot';

          const badge = document.createElement('span');
          badge.className = 'availability-low-stock';
          badge.appendChild(dot);
          badge.appendChild(document.createTextNode(text));
          container.appendChild(badge);
        }
        return;
      }

      const isTomorrow = deliveryDate === 'tomorrow' || deliveryDate === tomorrow;
      const soldOutLabel = isTomorrow
        ? locales.availability_sold_out_tomorrow
        : locales.availability_sold_out_today;

      if (availability.is_available_tomorrow && !isTomorrow) {
        setSoldOutState(soldOutLabel, locales.availability_reserve_tomorrow, 'tomorrow');
      } else if (availability.is_available_today && isTomorrow) {
        setSoldOutState(soldOutLabel, locales.availability_reserve_today, 'today');
      } else {
        setSoldOutState(locales.availability_sold_out);
      }
    } catch (error) {
      console.error('Error checking availability:', error);
    } finally {
      checking = false;
    }
  }

  checkAvailability();
  document.addEventListener('deliveryConfigSaved', checkAvailability);
})();
